function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-continue */

/* eslint-disable no-prototype-builtins */

/* eslint-disable no-restricted-syntax */
import jwtDecode from 'jwt-decode';
import api from "./api";
import logger from "./logger";
import storage from "./storage";
import string from "./utils/string";
/**
 * Security service in charge of authentication & check users permissions.
 */

export default {
  /**
   * @type {object} - Matrix loaded from API
   */
  matrix: {},

  /**
   * Init matrix and refresh user data
   *
   * @return {Promise}
   */
  init: function init() {
    var _this = this;

    return api.get('/matrix').then(function (_ref) {
      var data = _ref.data;
      _this.matrix = data.matrix;
      _this.user = data.user;
      logger.success('Security', 'Matrix has been loaded', _this.matrix);
      logger.success('Security', 'User has been refreshed', _this.user);
    });
  },

  /**
   * Authenticate user with username/password couple
   *
   * @param {string}  username
   * @param {string}  password
   * @param {boolean} authenticate
   *
   * @return {Promise}
   */
  login: function login(username, password) {
    var _this2 = this;

    var authenticate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return api.post('/login_check', {
      username: username,
      password: password
    }, null, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (_ref2) {
      var data = _ref2.data;
      return authenticate ? _this2.authenticate(data.token, data.refresh_token) : data;
    });
  },

  /**
   * Connect user
   *
   * @param {string} token
   * @param {string} refreshToken
   *
   * @return {object}
   */
  authenticate: function authenticate(token, refreshToken) {
    var data = jwtDecode(token);
    this.user = _objectSpread(_objectSpread({}, this.user), data.user);
    this.token = token;
    this.tokenExp = data.exp;
    this.refreshToken = refreshToken;
    this.refreshTokenExp = data.refreshExp;
    return this.user;
  },

  /**
   * Disconnect user
   *
   * @param {boolean} redirectToLogin
   */
  deAuthenticate: function deAuthenticate() {
    storage.storage_name = 'wever_app';
    this.user = undefined;
    this.token = undefined;
    this.tokenExp = undefined;
    this.refreshToken = undefined;
    this.refreshTokenExp = undefined;
    storage.delete();
    return true;
  },

  /**
   * Is user authenticated
   *
   * @return {boolean}
   */
  isAuthenticated: function isAuthenticated() {
    return (_typeof(this.user) === 'object' || typeof this.token === 'string') && (this.user !== 'undefined' || this.token !== 'undefined');
  },

  /**
   * Is token expired
   *
   * @return {boolean}
   */
  isTokenExpired: function isTokenExpired() {
    return this.tokenExp < Date.now() / 1000;
  },

  /**
   * Is refresh token expired
   *
   * @return {boolean}
   */
  isRefreshTokenExpired: function isRefreshTokenExpired() {
    return this.refreshTokenExp < Date.now() / 1000;
  },

  /**
   * Check if user has specific roles
   *
   * @param {array|string} roles  - roles to check
   * @param {boolean}      strict - if roles is array & strict is true, user must have all roles
   * @param {?object}      user   - Use current user if this var is not defined
   *
   * @return {boolean}
   */
  isGranted: function isGranted(roles) {
    var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var user = arguments.length > 2 ? arguments[2] : undefined;

    if (!this.isAuthenticated()) {
      return roles.length === 0;
    }

    var userTmp = user || this.user;

    if (!userTmp || !userTmp.roles || !Array.isArray(userTmp.roles)) {
      return false;
    } // cast roles to array


    var tmpRoles = !Array.isArray(roles) ? [roles] : roles;

    if (tmpRoles.length === 0 || userTmp.roles.includes('ROLE_SUPER_ADMIN')) {
      return true;
    }

    var has = tmpRoles.filter(function (role) {
      return userTmp.roles.includes(role);
    }).length;
    return strict ? has === tmpRoles.length : has > 0;
  },

  /**
   * Check if user has permission on specific action
   *
   * @param {string}   alias
   * @param {string}   operation
   * @param {?boolean} checkRoles
   * @param {?object}   user
   *
   * @return {boolean|null}
   */
  hasPermission: function hasPermission(alias, operation) {
    var checkRoles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var user = arguments.length > 3 ? arguments[3] : undefined;

    if (this.isGranted('ROLE_SUPER_ADMIN', true, user)) {
      return true;
    }

    var tmpAlias = string.ucfirst(alias);
    var tmpUser = user || this.user;

    if (tmpUser && tmpUser.permissions && Array.isArray(tmpUser.permissions[tmpAlias])) {
      if (tmpUser.permissions[tmpAlias].includes("!".concat(operation))) {
        return false;
      }

      if (tmpUser.permissions[tmpAlias].includes(operation)) {
        return true;
      }
    }

    if (checkRoles) {
      return this.hasRequiredRoles(tmpAlias, operation, tmpUser);
    }

    return null;
  },

  /**
   * Check if user has permission on specific actions
   *
   * @param {object}  permissions
   * @param {boolean} useRoles
   *
   * @return {boolean}
   */
  hasPermissions: function hasPermissions() {
    var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var useRoles = arguments.length > 1 ? arguments[1] : undefined;
    var user = arguments.length > 2 ? arguments[2] : undefined;

    if (this.isGranted('ROLE_SUPER_ADMIN', true, user)) {
      return true;
    }

    for (var alias in permissions) {
      if (!permissions.hasOwnProperty(alias)) {
        continue;
      }

      for (var i = 0, len = permissions[alias].length; i < len; ++i) {
        if (!this.hasPermission(alias, permissions[alias][i], useRoles, user)) {
          return false;
        }
      }
    }

    return true;
  },

  /**
   * Has required role for actions as defined in matrix
   *
   * @param {string}  module
   * @param {string}  operation
   * @param {?object} user
   *
   * @return {boolean}
   */
  hasRequiredRoles: function hasRequiredRoles(module, operation, user) {
    if (this.isGranted('ROLE_SUPER_ADMIN', true, user)) {
      return true;
    }

    var config = this.getOperationConfig(module, operation);
    return !config || this.isGranted(config.roles, false, user);
  },

  /**
   * Get operation config in matrix
   *
   * @param {string} module
   * @param {string} operation
   *
   * @return {null|object}
   */
  getOperationConfig: function getOperationConfig(module, operation) {
    var matrix = this.matrix;

    for (var i = 0, len = matrix.length; i < len; ++i) {
      var _matrix$i = matrix[i],
          alias = _matrix$i.alias,
          operations = _matrix$i.operations;

      if (alias.toLowerCase() === module.toLowerCase() && operations[operation]) {
        return operations[operation];
      }
    }

    return null;
  },

  /**
   * Get user from storage
   *
   * @return {?object}
   */
  get user() {
    return storage.get('user');
  },

  /**
   * Set user data into storage
   *
   * @param {object} user
   */
  set user(user) {
    storage.set('user', user);
  },

  /**
   * Get token from storage
   *
   * @return {?string}
   */
  get token() {
    return storage.get('token');
  },

  /**
   * Set token data into storage
   *
   * @param {string} token
   */
  set token(token) {
    storage.set('token', token);
  },

  /**
   * Get token exp from storage
   *
   * @return {number}
   */
  get tokenExp() {
    var _storage$get;

    return Number((_storage$get = storage.get('token-exp')) !== null && _storage$get !== void 0 ? _storage$get : 0);
  },

  /**
   * Set token exp data into storage
   *
   * @param {number} exp
   */
  set tokenExp(exp) {
    storage.set('token-exp', exp);
  },

  /**
   * Get refresh token from storage
   *
   * @return {?string}
   */
  get refreshToken() {
    return storage.get('refresh-token');
  },

  /**
   * Set refresh token into storage
   *
   * @param {string} token
   */
  set refreshToken(token) {
    storage.set('refresh-token', token);
  },

  /**
   * Get refresh token exp from storage
   *
   * @return {number}
   */
  get refreshTokenExp() {
    var _storage$get2;

    return Number((_storage$get2 = storage.get('refresh-token-exp')) !== null && _storage$get2 !== void 0 ? _storage$get2 : 0);
  },

  /**
   * Set refresh token exp into storage
   *
   * @param {number} exp
   */
  set refreshTokenExp(exp) {
    storage.set('refresh-token-exp', exp);
  }

};